import { Controller } from "@hotwired/stimulus"

// Opens/closes a native <dialog> styled as the pop-art modal.
//
//   %div{data: { controller: "dialog" }}
//     %button{data: { action: "dialog#open" }} Del
//     %dialog.modal{data: { dialog_target: "dialog", action: "click->dialog#backdropClose" }}
//       ...
//       %button{data: { action: "dialog#close" }}
export default class extends Controller {
  static targets = ["dialog"]
  static values = { open: Boolean }

  connect() {
    if (this.openValue) this.dialogTarget.showModal()
  }

  open(event) {
    event.preventDefault()
    this.dialogTarget.showModal()
  }

  close(event) {
    if (event) event.preventDefault()
    this.dialogTarget.close()
  }

  // A click on the <dialog> element itself (not its children) is a click on
  // the backdrop area.
  backdropClose(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
